import { Component, computed, effect, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { TableModule } from 'primeng/table';
import { selectPredictions } from '../../../../store/selectors/prediction.selectors';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import {  loadUserPredictions } from '../../../../store/actions/prediction.actions';
import { Router } from '@angular/router';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { PredictionService } from '../../../../services/prediction.service';

@Component({
  selector: 'app-manage-predictions-table',
  imports: [TableModule, CommonModule, ButtonModule, ConfirmDialogModule, ToastModule],
  providers: [ConfirmationService],
  templateUrl: './manage-predictions-table.component.html',
  styleUrl: './manage-predictions-table.component.scss'
})
export class ManagePredictionsTableComponent {
  private store = inject(Store);
  private router = inject(Router);
  private confirmationService = inject(ConfirmationService)
  private messageService = inject(MessageService);
  private predictionService = inject(PredictionService);
  predictions = this.store.selectSignal(selectPredictions)

  sortedPredictions = computed(()=> {
    return this.predictions().slice().sort((a, b) => {
      const dateA = new Date(a.created_at);
      const dateB = new Date(b.created_at);
      return dateB.getTime() - dateA.getTime(); 
    });
  })
  editPrediction(prediction: any) {
    this.router.navigate(['/admin/prediction', prediction.id, 'edit']);
  }
  deletePrediction(prediction: any, event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Voulez-vous vraiment supprimer cette prédiction ?',
      header: 'Confirmation',
      icon: 'pi pi-info-circle',
      rejectLabel: 'Cancel',
      rejectButtonProps: {
        label: 'Annuler',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Supprimer',
        severity: 'danger',
      },

      accept: () => {
        this.predictionService.deletePrediction(prediction).subscribe({
          next: () => {
            this.store.dispatch(loadUserPredictions({ userId: JSON.parse(localStorage.getItem('user') || '{}').user_id }));
            this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'Prédiction supprimée avec succès' });
          },
          error: (err) => {
            console.error('Error deleting prediction:', err);
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete prediction' });
          }
        })
      },
      reject: () => {
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected' });
      },
    });
   
  }



}
